module.exports = __webpack_public_path__ + "img/news.bf10bb5d.svg";